export default "__VITE_ASSET__E49pIi87__"